import { getCurrentUser } from '@back-office/core';
import { http } from '../config';
import { INVOICES_ENDPOINT, POLLING_ENDPOINT } from '../endpoints';
import { InvoiceResponse, InvoicesRequest } from '../types';

export async function postInvoice(
  body: InvoicesRequest
): Promise<InvoiceResponse> {
  const currentUser = getCurrentUser();
  return http.put(INVOICES_ENDPOINT, body, {
    params: { merchantID: currentUser.merchantID },
  });
}

export async function getInvoice(txId: string): Promise<InvoiceResponse> {
  const currentUser = getCurrentUser();
  return http.get(`${POLLING_ENDPOINT}/${txId}`, {
    params: { merchantID: currentUser.merchantID },
  });
}
